// extracted by mini-css-extract-plugin
export default {"box":"model-label_box__eRSUs","label":"model-label_label__OIHUW"};